export default __webpack_public_path__ + "static/media/660.d641ae4a.png";